import UserSession from '@/infrastructure/user-session';

export default class App {
	public readonly page: string;
	public readonly isUserSessionValid: boolean;

	public constructor(page: string | undefined) {
		this.page = page || 'ScholarshipEditor';
		this.isUserSessionValid = UserSession.isValid();
	}

	public mounted(): void {
		// Hook mounted
	}
}
